import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
import { AccountBookFilled } from "@ant-design/icons";
import Account from "./account";
function MyAccount() {
  const [activeKey, setActiveKey] = useState("My Account");

  const TabItems = [
    {
      key: "1",
      label: "My Account",
      icons: <AccountBookFilled />,
    },
    // {
    //   key: "2",
    //   label: "Transaction History",
    //   icons: <TransactionOutlined />,
    // },
  ];
  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title>My Account | PMT</title>
        </MetaTags>

        <Row className="mb-10">
          <Col span={24}>
            <div className="my-account-image">{/* PMTC */}</div>
          </Col>
          <Col span={24} className="my-account-tabs-section">
            <div className="flex rounded-lg">
              <div className="w-[20%] h-[120px] p-2 rounded-md my-account-tabs">
                {TabItems.map((tab) => (
                  <div
                    key={tab.key}
                    onClick={() => setActiveKey(tab.label)}
                    className={
                      activeKey === tab.label
                        ? "text-[#3498db] flex mb-2 bg-[#f1eeee] border-l-2 pt-2 pb-2 pl-2 border-blue-500 pl-2 cursor-pointer hover:text-[#3498db]"
                        : "flex mb-2 cursor-pointer pt-2 pb-2 pl-2 hover:text-[#3498db]"
                    }
                  >
                    {/* <div className="mr-2">{tab.icons}</div> */}
                    <p>{tab.label}</p>
                  </div>
                ))}
              </div>
              <div className="my-account-component-section">
                {activeKey !== "My Account" ? "No Data found" : <Account />}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default MyAccount;
